module.exports = __webpack_public_path__ + "media/106.2370d6d6.wav";